import firebase from "store/firebase"

function* signOut(action) {
  try {
    yield firebase.signOut(() => console.log("signed out"))
  } catch (error) {}
}

export default signOut
